<section class="steps-container">

    <div class="step" [ngClass]="{'completed': step >= 1}">
      <div class="circle" [ngClass]="{'circle-full': step > 1}">
        <span class="icon" style="color: white;" *ngIf="step >= 2"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 1"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    <div class="line" [ngClass]="{'completed': step >= 2, 'line-step': step >= 1}"></div>
    <div class="step" [ngClass]="{'completed': step >= 2}">
      <div class="circle" [ngClass]="{'circle-full': step > 2}">
        <span class="icon" style="color: white;" *ngIf="step >= 3"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 2"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    <div class="line" [ngClass]="{'completed': step >= 3, 'line-step': step >= 2 }"></div>
    <div class="step" [ngClass]="{'completed': step >= 3}">
      <div class="circle" [ngClass]="{'circle-full': step > 3}">
        <span class="icon" style="color: white;" *ngIf="step >= 4"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 3"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    <div class="line" [ngClass]="{'completed': step >= 4, 'line-step': step >= 3 }"></div>
    <div class="step" [ngClass]="{'completed': step >= 4}">
      <div class="circle" [ngClass]="{'circle-full': step > 4}">
        <span class="icon" style="color: white;" *ngIf="step >= 5"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 4"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    <div class="line" [ngClass]="{'completed': step >= 5, 'line-step': step >= 4 }"></div>
    <div class="step" [ngClass]="{'completed': step == 5}">
      <div class="circle" [ngClass]="{'circle-full': step > 5}">
        <span class="icon" style="color: white;" *ngIf="step >= 6"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 5"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    <div class="line" [ngClass]="{'completed': step >= 6, 'line-step': step >= 5 }"></div>
    <div class="step" [ngClass]="{'completed': step == 6}">
      <div class="circle" [ngClass]="{'circle-full': step > 6}">
        <span class="icon" style="color: white;" *ngIf="step >= 7"><i class='bx bx-check'></i></span>
        <span class="icon" *ngIf="step == 6"><i class='bx bxs-circle'></i></span>
      </div>
    </div>

    
  </section>